/** Implementation */
export function getAnalyticsMetadata(results, options) {
    if (!results?._rawResults) {
        return options ? undefined : [];
    }
    if (options?.indexUid) {
        // Find the specific index
        const rawResult = results._rawResults.find((raw) => raw.index === options.indexUid);
        return rawResult?._meilisearch?.metadata;
    }
    // Return all metadata
    return results._rawResults
        .map((raw) => raw._meilisearch?.metadata)
        .filter((metadata) => !!metadata);
}
//# sourceMappingURL=analytics-metadata.js.map